// material-ui
import { withStyles } from "@material-ui/core/styles";
// custom
import Table from "components/Table";
import PropTypes from "prop-types";
import React, { Component } from "react";
// styles
import styles from "./styles";

class EventReasonsList extends Component {
  static propTypes = {
    classes: PropTypes.object,
    eventReasons: PropTypes.array,
    onSelect: PropTypes.func,
  };

  onSelect(selectedEventReason) {
    const { onSelect } = this.props;
    this.setState({ selectedEventReason });
    if (onSelect) {
      onSelect(selectedEventReason);
    }
  }

  render() {
    const { eventReasons } = this.props;

    return (
      <Table
        data={eventReasons}
        meta={[
          {
            path: "name",
            title: "Name",
            numeric: false,
          },
        ]}
        title={"Event Reasons"}
        onRowSelect={this.onSelect.bind(this)}
      />
    );
  }
}

export default withStyles(styles)(EventReasonsList);
